export const SET_CUSTOMER = 'SET_CUSTOMER'
export const REG_CUSTOMER = 'REG_CUSTOMER'
export const LOGIN = 'LOGIN'
export const REGISTER = 'REGISTER'
export const LOGOUT = 'LOGOUT'
export const FB_LOGIN = 'FB_LOGIN'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILED = 'LOGIN_FAILED'
